import { Helmet } from 'react-helmet-async';
import { useCallback, useEffect, useRef, useState } from 'react';
import {
  Grid,
  Button,
  Container,
  Stack,
  Typography,
  TextField,
  Box,
  CircularProgress,
  IconButton,
  MenuItem,
  Select,
  Modal,
  Paper,
  Autocomplete,
  InputLabel,
  FormControl,
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { useDropzone } from 'react-dropzone';
import { toast, ToastContainer } from 'react-toastify';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import CachedIcon from '@mui/icons-material/Cached';
import { CopyAll } from '@mui/icons-material';

// components
import { useFilter } from '../layouts/dashboard/FilterProvider';
import WhatsappApiFunctions from '../API/whatsapp';
import Iconify from '../components/iconify';
import { BlogPostCard, BlogPostsSort, BlogPostsSearch } from '../sections/@dashboard/blog';
import POSTS from '../_mock/blog';
import Timer from './Whatsapp/Timer';
import SessionTimedoutModal from '../components/logout/LogoutModal';
import { DynamicTemplate } from './Whatsapp/DynamicTemplate';
import EventModal from './Whatsapp/CreateEventModal';
import TestUserModal from './Whatsapp/TestUserModal';
import UpdateEventModal from './Whatsapp/UpdateModal/UpdateEventModal';

// ----------------------------------------------------------------------

const SORT_OPTIONS = [
  { value: 'latest', label: 'Latest' },
  { value: 'popular', label: 'Popular' },
  { value: 'oldest', label: 'Oldest' },
];

// ----------------------------------------------------------------------

const numberOptions = ['1234567890', '0987654321', '1122334455', '2233445566'];

const URL = process.env.REACT_APP_API_ENDPOINT;

export default function BlogPage() {
  const fileInputRef = useRef(null);
  const { setFilter, filter } = useFilter();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [testNumberError, setTestNumberError] = useState('');
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sheets, setSheets] = useState([]);
  const [columns, setColumns] = useState([]);

  const [selectedSheet, setSelectedSheet] = useState('');
  const [selectedColumn, setSelectedColumn] = useState({});
  const [validNumbers, setValidNumbers] = useState([]);
  const [invalidNumbers, setInvalidNumbers] = useState([]);
  const [testNumber, setTestNumber] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [templateList, setTemplateList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [validNumbersCount, setValidNumbersCount] = useState(0);
  const [workbook, setWorkbook] = useState(null); // Store the parsed workbook
  const [binaryString, setBinaryString] = useState(null);
  const [testButtonDiable, setTestButtonDiable] = useState(true);
  const phoneUtil = PhoneNumberUtil.getInstance();
  const [startTimer, setStartTimer] = useState(false);
  const [isTimeRunning, setIsTimeRunning] = useState(false);
  const [isCreatEventModalOpen, setIsCreatEventModalOpen] = useState(false);
  const isExcel = file?.name?.split('.')?.pop()?.toLowerCase() !== 'csv';
  const [isCopied, setIsCopied] = useState(false);
  const [bulkMessageBtnLoading, setBulkMessageBtnLoading] = useState(false);
  const [refresh, setRefresh] = useState(true);

  const [isRotating, setIsRotating] = useState(false);

  const url = `${URL}Message/sendMessage?Name={
    name
  }&Number={number}&Category={category}&Timing={timing}&EventKey=${selectedEvent?.EventsDetailKey}`;
  console.log(selectedEvent);

  const paramsOfSelectedTemplate = templateList
    ?.filter((item) => item?.MessageTemplateKey === selectedTemplate?.MessageTemplateKey)[0]
    ?.UserParameters?.split(',');

  const handleEventModal = () => {
    setIsCreatEventModalOpen(true); //
  };

  const handleColumnTypes = (value) => {
    console.log(value);
    const result = value.UserParameters.split(',').reduce((acc, key) => {
      acc[key] = '';
      return acc;
    }, {});
    setSelectedColumn(result);
  };

  useEffect(() => {
    if (selectedTemplate && testNumber.length === 10) {
      setTestButtonDiable(false);
    } else {
      setTestButtonDiable(true);
    }
  }, [selectedTemplate, testNumber]);

  const handleSubmitTestNumber = async () => {
    setTestButtonDiable(true);

    if (testNumber.length > 0) {
      const phoneNumber = phoneUtil.parse(testNumber, 'IN'); // Example: 'US', 'IN'
      if (phoneNumber && phoneUtil.isValidNumber(phoneNumber)) {
        setTestNumberError('');
        try {
          const response = await WhatsappApiFunctions.testNumber(testNumber, selectedTemplate.MessageTemplateKey);
          const { Parameters } = response;
          setTemplateList(Parameters);
          toast.success('Message sent', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setStartTimer(true);
          setIsTimeRunning(true);
          setTestButtonDiable(false);
        } catch (error) {
          console.error('Error fetching message count:', error);
          toast.error('Something went wrong', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        setTestButtonDiable(false);
      } else {
        setTestNumberError('Please enter a valid phone number.');
      }
    }
    setTestButtonDiable(false);
    setTestNumber('');
  };

  const sendBulkMsg = async () => {
    setBulkMessageBtnLoading(true);
    try {
      const { response, status } = await WhatsappApiFunctions.sendBulkMsg(
        file,
        selectedEvent.EventsDetailKey,
        JSON.stringify(selectedColumn),
        selectedSheet
      );
      if (response.status === 200) {
        setFile(null);
        setSelectedTemplate(null);
        setSelectedEvent(null);
        toast.success('Response sent successfully', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error('Something went wrong', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error('Something went wrong', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.error('Error sending bulk message:', error);
    } finally {
      setBulkMessageBtnLoading(false);
    }
  };

  const handleButtonClick = () => {
    // Programmatically trigger file input click
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileInputChange = (e) => {
    if (e.target.files.length === 0) {
      // setIsButtonDisabled(false);
      return;
    }

    const uploadedFile = e.target.files[0];
    if (uploadedFile) {
      setIsButtonDisabled(true);
      setIsUploading(true);
      setFile(uploadedFile);

      const fileExtension = uploadedFile.name.split('.').pop().toLowerCase();

      if (fileExtension === 'csv') {
        // Handle CSV file
        Papa.parse(uploadedFile, {
          header: true,
          complete: (result) => {
            // Process CSV data here
            readFile(uploadedFile);
          },
          error: (error) => {
            console.error('Error parsing CSV:', error);
          },
        });
      } else if (fileExtension === 'xls' || fileExtension === 'xlsx') {
        // Handle Excel file
        const reader = new FileReader();
        reader.onload = (event) => {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetNames = workbook.SheetNames;
          const sheet = workbook.Sheets[sheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          // Process Excel data here
          readFile(uploadedFile);
        };
        reader.readAsArrayBuffer(uploadedFile);
      } else {
        console.error('Unsupported file type');
        setIsUploading(false);
      }
    }
    e.target.value = '';
    // setIsButtonDisabled(false);
  };

  const readFile = (file) => {
    const fileExtension = file.name.split('.').pop().toLowerCase();

    if (fileExtension === 'csv') {
      // Handle CSV file
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          const columnsList = result.data[0] ? Object.keys(result.data[0]) : [];
          setColumns(columnsList);
          // setSelectedColumn(result.meta.fields[0]);
          setValidNumbersCount(result.data.length);
          setSheets(['CSV Data']); // Example: update with actual sheet names or structure
          setSelectedSheet(['CSV Data'][0]);
          setIsUploading(false);
          //  setIsModalOpen(true);
        },
        error: (error) => {
          console.error('Error parsing CSV:', error);
          setIsUploading(false);
        },
      });
    } else if (fileExtension === 'xls' || fileExtension === 'xlsx') {
      // Handle Excel file
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        setWorkbook(workbook);
        setSheets(workbook.SheetNames);
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const sheetRows = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
        setValidNumbersCount(Math.max(sheetRows.length - 1, 0));
        setIsUploading(false);
        setIsModalOpen(true);
      };
      reader.readAsArrayBuffer(file);
    } else {
      console.error('Unsupported file type');
      setIsUploading(false);
    }
  };

  // Dropzone configuration
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (selectedTemplate) {
        const uploadedFile = acceptedFiles[0];
        if (uploadedFile) {
          const reader = new FileReader();
          reader.onload = () => {
            const csvData = reader.result; // <--- Change this line

            // setSelectedColumn(csvData.data[0]);
            setSelectedSheet(uploadedFile.name.split('.csv')[0]);

            const utf8Array = new TextEncoder().encode(csvData);
            const binaryString = btoa(String.fromCharCode.apply(null, utf8Array));
            setBinaryString(binaryString);
            setIsModalOpen(true);
          };
          reader.readAsText(uploadedFile, 'utf-8');
          setIsUploading(true);
          setFile(uploadedFile);
          readFile(uploadedFile);
        }
      }
    },
    [selectedTemplate]
  );

  // Dropzone setup
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: '.csv, .xls, .xlsx',
    multiple: false,
  });

  // Sheet selection handler
  const handleSheetSelect = (e) => {
    const sheetName = e.target.value;
    setSelectedSheet(sheetName);

    // If the file is CSV
    if (file.name.endsWith('.csv')) {
      Papa.parse(file, {
        header: true,
        complete: (result) => {
          const columnsList = result.data[0] ? Object.keys(result.data[0]) : [];
          setColumns(columnsList);
        },
        error: (error) => {
          console.error('Error parsing CSV:', error);
        },
      });
    } else {
      // If the file is Excel
      // const workbook = workbook.read(file, { type: 'array' });
      // console.log('sheet');
      const sheet = workbook.Sheets[sheetName];

      const sheetRows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      setColumns(sheetRows[0]);
      setValidNumbersCount(Math.max(sheetRows.length - 1, 0));
    }
  };

  // Column selection and phone number validation
  const handleColumnSelect = (e) => {
    const column = e.target.value;
    const name = e.target.name;
    // setSelectedColumn(column);
    setSelectedColumn((prev) => ({ ...prev, [name]: column }));

    if (file.name.endsWith('.csv')) {
      // Handle CSV file
      Papa.parse(file, {
        complete: (result) => {
          const rows = [result.data];

          if (Array.isArray(rows) && rows.length > 0) {
            // Ensure that the first row contains the headers
            const headers = rows[0];
            if (Array.isArray(headers)) {
              // Find the column index by matching the header with the selected column
              const columnIndex = 1;

              if (columnIndex !== -1) {
                const binaryString = rows[0].map((row) => row.join(',')).join('\n');
                setBinaryString(btoa(binaryString));
                // Extract phone numbers from the selected column
                const phoneNumbers = rows[0];

                // Filter valid phone numbers
                const validPhoneNumbers = phoneNumbers?.filter((number) => number && validatePhoneNumbers(number));

                // Store valid numbers (total entry count is set once when the file is parsed)
                setValidNumbers(validPhoneNumbers);
              } else {
                console.error('Selected column not found in CSV headers.');
              }
            } else {
              console.error('CSV file does not have valid headers.');
            }
          } else {
            console.error('CSV file has no data.');
          }
        },
        header: true, // Ensures the first row is treated as headers
        skipEmptyLines: true, // Optional: skips empty lines in the CSV
      });
    } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
      // Handle Excel file
      if (!workbook) {
        console.error('Workbook is not available.');
        return;
      }

      const sheet = workbook?.Sheets[selectedSheet];

      if (!sheet) {
        alert('no Sheet');
        console.error('Selected sheet not found.');
      }
      // Total entry count is set once when the file/sheet is parsed (see readFile / handleSheetSelect)
    }
  };

  const validatePhoneNumbers = (column) => {
    const workbook = XLSX.read(file, { type: 'string', raw: true });
    const sheet = workbook.Sheets[selectedSheet];
    const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });
    const colIndex = rows[0].indexOf(column);

    const valid = [];
    const invalid = [];
    rows.slice(1).forEach((row) => {
      const phoneNumber = row[colIndex];
      try {
        const parsedNumber = phoneUtil.parse(phoneNumber, 'IN');
        if (phoneUtil.isValidNumber(parsedNumber)) {
          valid.push(phoneNumber);
        } else {
          invalid.push(phoneNumber);
        }
      } catch (error) {
        invalid.push(phoneNumber);
      }
    });

    setValidNumbers(valid);
    setInvalidNumbers(invalid);
  };

  // Modal closing and resetting the state
  const handleCloseModal = () => {
    setIsModalOpen(false);
    //  setFile(null);
    //  setSelectedSheet('');
    //  setSelectedColumn('');
    //  setSheets([]);
    //  setColumns([]);
    //  setValidNumbers([]);
    //  setInvalidNumbers([]);
  };

  const handleTimeUp = () => {
    setIsTimeRunning(false);
  };

  const handleRefresh = () => {
    setIsRotating(true);
    setRefresh((prev) => !prev);
    setTimeout(() => setIsRotating(false), 500); // Reset after animation duration
  };
  async function getEventList(templateKey) {
    try {
      const response = await WhatsappApiFunctions.getEventList(templateKey);
      const { Events } = response;
      // setMessageCount(MessageCount);
      setEventList(Events);
    } catch (error) {
      console.error('Error fetching message count:', error);
      setEventList([]);
    }
  }
  const handleCopy = async (event) => {
    try {
      await navigator.clipboard.writeText(url);
      setIsCopied(true);

      // Hide Popper after 2 seconds
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };
  useEffect(() => {
    async function getTempleList() {
      try {
        const response = await WhatsappApiFunctions.getTempleList();
        const { Templates } = response;
        // setMessageCount(MessageCount);
        setTemplateList(Templates);
        setSelectedTemplate(Templates[0]);
      } catch (error) {
        console.error('Error fetching message count:', error);
      }
    }
    getTempleList();
  }, [refresh]);

  useEffect(() => {
    getEventList(selectedTemplate?.MessageTemplateKey);
  }, [filter.eventCount, refresh]);

  useEffect(() => {
    if (localStorage.getItem('endTime')) {
      setIsTimeRunning(true);
    }
  }, []);

  console.log(selectedEvent?.EventsDetailKey);

  return (
    <>
      <Helmet>
        <title> Whatsapp</title>
      </Helmet>
      <Container mt={0}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
          <Typography variant="h4" gutterBottom>
            Create Campaign
          </Typography>

          {/* <CreateEventModal isModalOpen={isCreatEventModalOpen} handleModal={handleEventModal} /> */}
          {/* <TemplateForm/> */}
          <Stack direction="row" gap={2}>
            <IconButton
              onClick={handleRefresh}
              sx={{ position: 'relative', borderRadius: '12px', background: '#E0E4E8' }}
            >
              <CachedIcon
                sx={{
                  transition: 'transform 0.5s ease-in-out',
                  transform: isRotating ? 'rotate(360deg)' : 'rotate(0deg)',
                }}
              />
            </IconButton>
            <UpdateEventModal />
            <EventModal />
          </Stack>
        </Stack>
        <Grid container spacing={2} item xs={12} mb={3} sx={{ height: 'max-content' }}>
          <Grid item xs={7} sx={{ height: 'max-content' }}>
            <Grid container direction="row" gap={2} sx={{ height: 'max-content' }}>
              <Grid item xs={12}>
                {/* <TextField
                  label="Template Name"
                  value={selectedTemplate?.TemplateName || ''}
                  sx={{ width: '100%' }}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                /> */}
                <Stack gap={1} mt={2}>
                  {/* <Typography sx={{ fontSize: '1rem', fontWeight: '600', width: 'max-content' }}>
                    Select Template *{' '}
                  </Typography> */}
                  <Grid container>
                    <Grid item xs={12}>
                      <Autocomplete
                        options={templateList}
                        getOptionLabel={(option) => option.TemplateName} // Display TemplateName in the input field
                        renderInput={(params) => (
                          <TextField {...params} label="Template" autoFocus variant="outlined" sx={{ width: '100%' }} />
                        )}
                        onChange={(event, value) => {
                          if (value) {
                            setSelectedTemplate(value); // Store the selected template in state
                            handleColumnTypes(value);
                            setSelectedEvent(null);
                            setEventList([]);
                            getEventList(value?.MessageTemplateKey);
                            // handleMsgContent(value.MessageTemplateKey);
                          } else {
                            setSelectedTemplate(null); // Reset if no value is selected
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack gap={1} mt={2}>
                  {/* <Typography sx={{ fontSize: '1rem', fontWeight: '600', width: 'max-content' }}>
                    Select Event*{' '}
                  </Typography> */}
                  <Grid container>
                    <Grid item xs={12}>
                      <Autocomplete
                        options={eventList}
                        getOptionLabel={(option) => option?.EventsName} // Display TemplateName in the input field
                        renderInput={(params) => (
                          <TextField {...params} label="Select Event" variant="outlined" sx={{ width: '100%' }} />
                        )}
                        value={selectedEvent}
                        onChange={(event, value) => {
                          if (value) {
                            setSelectedEvent(value); // Store the selected template in state
                            // handleColumnTypes(value);
                            // handleMsgContent(value.MessageTemplateKey);
                          } else {
                            setSelectedEvent(null); // Reset if no value is selected
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </Stack>
              </Grid>
            </Grid>
            <Grid>
              {selectedTemplate?.MessageTemplateKey === 24000007 && selectedEvent ? (
                <>
                  <Grid item xs={12}>
                    <Paper
                      elevation={0}
                      sx={{
                        background: '#ebebeb',
                        pl: 2,
                        pt: 2,
                        pr: 2,
                        pb: 2,
                        mt: 1,
                        borderRadius: '12px',
                        width: '100%',
                      }}
                    >
                      <Stack
                        direction="row"
                        gap={2}
                        sx={{ width: '100%', cursor: 'pointer' }}
                      // onClick={handlePopoverOpen}
                      // onMouseLeave={() => handlePopoverClose()}
                      >
                        <LightbulbIcon sx={{ color: '#F1B92B', cursor: 'pointer' }} />
                        <Stack direction="column" sx={{ width: '100%' }}>
                          <Stack gap={0} sx={{ width: '100%' }}>
                            <Typography variant="h6" sx={{ margin: '0' }}>
                              Test message URL
                            </Typography>
                            <Stack direction={'row'} gap={2} sx={{ width: 'calc(100% - 40px)' }}>
                              <Typography
                                sx={{
                                  color: '',
                                  whiteSpace: 'nowrap', // Prevents text from wrapping
                                  overflowX: 'auto', // Enables horizontal scrolling
                                  display: 'block', // Ensures it takes full width
                                  width: '100%',
                                  paddingBottom: '10px',
                                }}
                              >
                                {url}
                              </Typography>
                              <IconButton
                                sx={{ width: '40px', height: '40px', borderRadius: '8px', position: 'relative' }}
                                onClick={handleCopy}
                              >
                                <CopyAll />
                                {isCopied ? (
                                  <div
                                    className="fadeOut"
                                    style={{
                                      background: '#333',
                                      color: '#fff',
                                      padding: '10px 12px',
                                      borderRadius: '4px',
                                      fontSize: '0.85rem',
                                      width: 'max-content',
                                      position: 'absolute',
                                      left: '50%',
                                      transform: 'translateX(-50%)',
                                      top: 'calc(100% + 20px)',
                                    }}
                                  >
                                    URL Copied!
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </IconButton>
                            </Stack>
                            <Typography sx={{ fontSize: '0.9rem', whiteSpace: 'break-all' }} variant="" color="grey">
                              * name, number, category, and timing must be passed in the URL *
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Paper>
                  </Grid>
                </>
              ) : (
                <></>
              )}
            </Grid>
            <Stack gap={1} mt={2}>
              <Typography variant="" sx={{ fontSize: '1rem', fontWeight: '600' }}>
                Upload Your File *
              </Typography>
              {/* <Grid container spacing={4}> */}
              {/* <Grid item xs={12} md={6}> */}
              <Box sx={{ mt: 0 }}>
                {isUploading ? (
                  <CircularProgress />
                ) : (
                  <Paper
                    {...(selectedTemplate ? getRootProps() : {})}
                    sx={{
                      padding: '20px',
                      textAlign: 'center',
                      border: '2px dashed grey',
                      backgroundColor: isDragActive ? '#f0f0f0' : '#fafafa',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      height: '200px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{ fontSize: '1.2rem', color: `${selectedTemplate ? 'black' : '#919EAB'}` }}
                    >
                      {isDragActive ? 'Drop the file here...' : 'Drag & drop a CSV file here, or click to select'}
                    </Typography>
                    {selectedTemplate && <input {...getInputProps()} />}

                    {file ? (
                      <>
                        {' '}
                        <Typography sx={{ mt: 2 }} variant="subtitle1">
                          Selected file: {file.name}
                        </Typography>{' '}
                        <Button
                          variant="contained"
                          component="label"
                          color="error"
                          sx={{ mt: 2 }}
                          disabled={isButtonDisabled}
                        >
                          Change File
                          {/* The input is embedded in the label so the button click will trigger it without the need for a click handler */}
                        </Button>
                        {selectedTemplate && (
                          <input
                            id="fileInput"
                            type="file"
                            hidden
                            accept=".csv, .xls, .xlsx"
                            onChange={handleFileInputChange}
                          />
                        )}
                      </>
                    ) : (
                      <>
                        {' '}
                        <Button
                          variant="contained"
                          component="label"
                          sx={{
                            mt: 2,
                            backgroundColor: '#9f1d21',
                            color: '#ffffff',
                            '&:hover': {
                              backgroundColor: '#e3272c',
                            },
                            '&:disabled': {
                              backgroundColor: '#f4aac9',
                              color: '#fff',
                            },
                          }}
                          onClick={handleButtonClick}
                          disabled={selectedTemplate === null || isButtonDisabled}
                        >
                          Select File
                        </Button>
                        {/* <input
                            id="fileInput"
                            type="file"
                            ref={fileInputRef}
                            hidden
                            accept=".csv, 
                           //  .xls, .xlsx
                           "
                            onChange={handleFileInputChange}
                          /> */}
                      </>
                    )}
                  </Paper>
                )}

                {/* {file && (
                  <Stack direction="row">
                    <span style={{ fontSize: '1rem', marginTop: '1rem', width: '100px' }}>Selected file</span>
                    <Typography sx={{ fontSize: '1rem', marginTop: '1rem' }}> : {file.name}</Typography>
                  </Stack>
                )} */}
                {file && (
                  <Stack gap={1} justifyContent="center" sx={{ height: '100%', width: '100%' }}>
                    <Stack direction={'row'} alignItems="center" mt={0.5}>
                      <Typography sx={{ fontSize: '1rem' }}>No. of Entries in the File</Typography>
                      <Typography sx={{ fontSize: '1rem' }}>: {validNumbersCount}</Typography>
                    </Stack>
                    {invalidNumbers?.length > 0 && (
                      <Typography variant="subtitle1" color="red">
                        Invalid Number : {invalidNumbers.length}
                      </Typography>
                    )}
                  </Stack>
                )}
                <Button
                  size="large"
                  variant="contained"
                  component="label"
                  sx={{
                    width: 'max-content',
                    marginTop: '1rem',
                    marginBottom: 'auto',
                    backgroundColor: '#9f1d21',
                    color: '#ffffff',
                    '&:hover': {
                      backgroundColor: '#e3272c',
                    },
                    '&:disabled': {
                      backgroundColor: '#f4aac9',
                      color: '#ffffff',
                    },
                  }}
                  ml={2}
                  mt={2}
                  onClick={sendBulkMsg}
                  disabled={bulkMessageBtnLoading || selectedTemplate === null || validNumbersCount === 0}
                >
                  Send Messages
                </Button>
                {/* Modal for displaying sheets and columns */}
                <Modal
                  open={isModalOpen}
                  onClose={handleCloseModal}
                  sx={{
                    display: 'flex',
                    alignItems: 'start',
                    justifyContent: 'center',
                    marginTop: '100px',
                    borderRadius: '1rem',
                  }}
                >
                  <Box
                    className="scrollbar"
                    sx={{
                      width: 600,
                      p: 4,
                      backgroundColor: 'white',
                      borderRadius: 1,
                      textAlign: 'center',
                      position: 'relative',
                      overflowY: 'scroll',
                      maxHeight: '80vh',
                    }}
                  >
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Typography textAlign="start" variant="h6" sx={{ fontSize: '1.2rem', width: 'max-content' }}>
                        {/* Select Sheet and Column */}
                        Configure Sheet and Column
                      </Typography>
                      <Button onClick={handleCloseModal} sx={{ padding: '0' }}>
                        <svg
                          width="40px"
                          height="40px"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                          <g id="SVGRepo_iconCarrier">
                            {' '}
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.9393 12L6.9696 15.9697L8.03026 17.0304L12 13.0607L15.9697 17.0304L17.0304 15.9697L13.0607 12L17.0303 8.03039L15.9696 6.96973L12 10.9393L8.03038 6.96973L6.96972 8.03039L10.9393 12Z"
                              fill="#080341"
                            />{' '}
                          </g>
                        </svg>
                      </Button>
                    </Stack>
                    <br />

                    {file?.name?.split('.')?.pop()?.toLowerCase() !== 'csv' && (
                      <>
                        <p style={{ fontSize: '1rem', width: 'max-content', padding: '0', margin: '0' }}>
                          Select Sheet
                        </p>
                        <Select
                          value={selectedSheet}
                          onChange={handleSheetSelect}
                          displayEmpty
                          fullWidth
                          sx={{ mt: 2 }}
                        >
                          {/* <MenuItem value="" disabled>
                          Select Sheet
                        </MenuItem> */}
                          {sheets.map((sheet) => (
                            <MenuItem key={sheet} value={sheet}>
                              {sheet}
                            </MenuItem>
                          ))}
                        </Select>
                      </>
                    )}
                    {/* {selectedSheet && (
                      <Select
                        value={selectedColumn?.PhoneNumber}
                        onChange={handleColumnSelect}
                        displayEmpty
                        fullWidth
                        sx={{ mt: 2 }}
                      >
                        <MenuItem value="" disabled>
                          Select Column
                        </MenuItem>
                        {columns.map((column) => (
                          <MenuItem key={column} value={column}>
                            {column}
                          </MenuItem>
                        ))}
                      </Select>
                    )} */}
                    {isExcel && (
                      <>
                        <br />
                        <br />
                      </>
                    )}
                    <p style={{ fontSize: '1rem', width: 'max-content', padding: '0', margin: '0' }}>Select Column</p>
                    {selectedSheet &&
                      paramsOfSelectedTemplate?.map((item, index) => {
                        return (
                          <>
                            <FormControl fullWidth sx={{ mt: 2 }}>
                              <InputLabel id="demo-simple-select-label" shrink>
                                {item}
                              </InputLabel>
                              <Select
                                label={`${item}`}
                                // labelId="demo-simple-select-label"
                                // id="demo-simple-select"
                                placeholder={`Select ${item}`}
                                name={item}
                                value={selectedColumn[item]}
                                onChange={handleColumnSelect}
                                displayEmpty
                                fullWidth
                                disabled={!selectedSheet}
                              >
                                {/* <MenuItem value="" disabled>
                                  Select {item}
                                </MenuItem> */}
                                {columns?.map((column) => (
                                  <MenuItem key={column} value={column}>
                                    {column}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </>
                        );
                      })}

                    <Button size="large" fullWidth variant="contained" sx={{ mt: 4 }} onClick={handleCloseModal}>
                      Submit
                    </Button>
                  </Box>
                </Modal>
              </Box>
              {/* </Grid> */}
              {/* </Grid> */}
            </Stack>
          </Grid>
          <Grid item xs={5} mt={1}>
            <Grid container>
              <DynamicTemplate
                template={selectedTemplate?.MessageContent}
                image={
                  selectedEvent?.CustomizedData || ''
                  // (eventList[0]?.CustomizedData && JSON.parse(eventList[0]?.CustomizedData?.ImagePath))
                }
              />
              <Grid item xs={12} mt={2}>
                <TestUserModal
                  eventKey={selectedEvent?.EventsDetailKey}
                  paramsOfSelectedTemplate={paramsOfSelectedTemplate}
                  inputString={selectedTemplate?.UserParameters}
                />
              </Grid>
            </Grid>{' '}
          </Grid>
        </Grid>
      </Container>
      <ToastContainer />
    </>
  );
}
